import styled from '@emotion/styled';
import { css_gap, css_text } from '~/emotion/theme';
import IconLogoRealtor from '~/icon/logo/IconLogoRealtor';
import IconLogoEqual from '~/icon/logo/IconLogoEqual';
import type { PoweredBlockVariant } from '~/editor/blocks/powered/common';
import MicrositeSection from '~/components/MicrositeSection';

const Footer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${css_gap('content')} 0;
`;

const Logo = styled.img`
	max-height: 4rem;
`;

const IconBox = styled.div`
	width: 3rem;
	height: 3rem;
`;

const Powered = styled.div`
	display: grid;
	gap: 0.25rem;
`;

const By = styled.div`
	font-size: 0.7rem;
	color: ${css_text('weak')};
	text-transform: uppercase;
`;

const Groups = styled.div`
	display: flex;
	gap: ${css_gap('content')};
`;

const Copywrite = styled.div`
	font-size: 0.7rem;
	color: ${css_text('weak')};
	text-transform: uppercase;
`;

export default function PoweredBlockBeta({ logo, legal }: PoweredBlockVariant) {
	return (
		<MicrositeSection>
			<Footer>
				<Powered>
					<By>Powered By:</By>
					<Logo src={logo} alt="Tenant logo" />
				</Powered>

				<Copywrite>
					&copy; {new Date().getFullYear()} {legal}
				</Copywrite>

				<Groups>
					<IconBox>
						<IconLogoRealtor />
					</IconBox>
					<IconBox>
						<IconLogoEqual />
					</IconBox>
				</Groups>
			</Footer>
		</MicrositeSection>
	);
}
